import { useTranslation } from "@privacy/translations";
import { DynamicGrid } from "../../dynamicGrid";
import { usePrivacyNavigate } from "../../shared/usePrivacyNavigate";
import { PageTitle } from "../../shared/Page";
import { usePermission } from "../../shared/permissions";
import { CreateDpiaDialog } from "./CreateDpiaDialog";
import { dpiaPreAssessmentFormQueryOptions } from "../../api/dpia";
import { prefetch } from "../../api/prefetch";

export const DpiaGridToolbar = () => {
  const { navigate, paths } = usePrivacyNavigate();
  const { t } = useTranslation();
  const { hasPermission } = usePermission();

  return (
    <DynamicGrid.Toolbar
      pageTitle={<PageTitle title={t("Dpia.Grid.Title")} subTitle={t("Dpia.Grid.SubTitle")} />}
      actionButtons={
        hasPermission("nova-forms-api:dpia:create") && (
          <DynamicGrid.CreateNewButton
            labelKey="CreateDpia.Button"
            renderDialog={({ onClose }) => (
              <CreateDpiaDialog
                onClose={onClose}
                onCreated={dpia => {
                  if (dpia.type === "external") {
                    navigate(paths.dpiaById(dpia.id));
                    return;
                  }
                  prefetch(dpiaPreAssessmentFormQueryOptions());
                  navigate(paths.dpiaPreAssessmentById(dpia.id));
                }}
              />
            )}
          />
        )
      }
    />
  );
};
